import React from "react";
import { createPages } from "../lib/AppView";

const Login = React.lazy(() => import(/* webpackChunkName: "login" */ "../pages/Login"));
const Registe = React.lazy(() => import(/* webpackChunkName: "registe" */ "../pages/Registe"));
const Slash = React.lazy(() => import(/* webpackChunkName: "slash" */ "../pages/Slash"));
const Admin = React.lazy(() => import(/* webpackChunkName: "Admin" */ "../pages/Admin"));
const Example = React.lazy(() => import(/* webpackChunkName: "Example" */ "../pages/Example"));
const Setting = React.lazy(() => import(/* webpackChunkName: "Setting" */ "../pages/Admin/Pages/Setting"));
const Main = React.lazy(() => import(/* webpackChunkName: "Main" */ "../pages/Admin/Pages/Main"));
const MainHeader = React.lazy(() => import(/* webpackChunkName: "MainHeader" */ "../pages/Admin/Pages/Main/Header"));
const AdminPage404 = React.lazy(() => import(/* webpackChunkName: "404" */ "../pages/Admin/Pages/404"));
const AdminMenuEdit = React.lazy(() => import(/* webpackChunkName: "AdminMenuEdit" */ "../pages/Admin/Pages/Menu/Edit"));
const AdminMenuList = React.lazy(() => import(/* webpackChunkName: "AdminMenuList" */ "../pages/Admin/Pages/Menu/List"));
const AdminLanguage = React.lazy(() => import(/* webpackChunkName: "AdminLanguage" */ "../pages/Admin/Pages/Language"));
const AdminFileRecord = React.lazy(() => import(/* webpackChunkName: "AdminFileRecord" */ "../pages/Admin/Pages/FileRecord"));
const MobileLogin = React.lazy(() => import(/* webpackChunkName: "MobileLogin" */ "../pages/MobileLogin"));
const AdminUserList = React.lazy(() => import(/* webpackChunkName: "AdminUserList" */ "../pages/Admin/Pages/User/List"));
const AdminUserGroupList = React.lazy(() => import(/* webpackChunkName: "AdminUserGroupList" */ "../pages/Admin/Pages/User/GroupList"));
const AdminUserEditGroup = React.lazy(() => import(/* webpackChunkName: "AdminUserEditGroup" */ "../pages/Admin/Pages/User/EditGroup"));
const AdminIFrame = React.lazy(() => import(/* webpackChunkName: "AdminIFrame" */ "../pages/Admin/Pages/IFrame"));
const ResourceCategory = React.lazy(() => import(/* webpackChunkName: "ResourceCategory" */ "../pages/Admin/Pages/Recource/Category"));
const ResourceCategoryEdit = React.lazy(() => import(/* webpackChunkName: "ResourceCategoryEdit" */ "../pages/Admin/Pages/Recource/CategoryEdit"));
const ResourceArticle = React.lazy(() => import(/* webpackChunkName: "ResourceArticle" */ "../pages/Admin/Pages/Article/List"));
const ResourceArticleEdit = React.lazy(() => import(/* webpackChunkName: "ResourceArticleEdit" */ "../pages/Admin/Pages/Article/Edit"));
const ResourceSpecialList = React.lazy(() => import(/* webpackChunkName: "ResourceSpecialList" */ "../pages/Admin/Pages/Recource/SpecialList"));
const ResourceSpecialListExtrac = React.lazy(() => import(/* webpackChunkName: "ResourceSpecialListExtrac" */ "../pages/Admin/Pages/Recource/SpecialListHead"));
const ResourceSpecialEdit = React.lazy(() => import(/* webpackChunkName: "ResourceSpecialEdit" */ "../pages/Admin/Pages/Recource/SpecialEdit"));
const ResourceSpecialCategory = React.lazy(() => import(/* webpackChunkName: "ResourceSpecialCategory" */ "../pages/Admin/Pages/Recource/SpecialCategory"));
const ResourceSpecialCategoryEdit = React.lazy(() => import(/* webpackChunkName: "ResourceSpecialCategoryEdit" */ "../pages/Admin/Pages/Recource/SpecialCategoryEdit"));
const ResourceSpecialGoodAt = React.lazy(() => import(/* webpackChunkName: "ResourceSpecialGoodAt" */ "../pages/Admin/Pages/Recource/SpecialGoodAt"));
const ResourceSpecialGoodAtEdit = React.lazy(() => import(/* webpackChunkName: "ResourceSpecialGoodAtEdit" */ "../pages/Admin/Pages/Recource/SpecialGoodAtEdit"));
const LawDocList = React.lazy(() => import(/* webpackChunkName: "LawList" */ "../pages/Admin/Pages/LawDocList/List"));
const LawDocEdit = React.lazy(() => import(/* webpackChunkName: "LawDocEdit" */ "../pages/Admin/Pages/LawDocList/Edit"));
const LawDocCategory = React.lazy(() => import(/* webpackChunkName: "LawDocCategory" */ "../pages/Admin/Pages/LawDocList/Category"));
const LawDocCategoryEdit = React.lazy(() => import(/* webpackChunkName: "LawDocCategoryEdit" */ "../pages/Admin/Pages/LawDocList/CategoryEdit"));
const ActivityEdit = React.lazy(() => import(/* webpackChunkName: "ActivityEdit" */ "../pages/Admin/Pages/Activity/Edit"));
const ActivityList = React.lazy(() => import(/* webpackChunkName: "ActivityList" */ "../pages/Admin/Pages/Activity/List"));
const ActivityApplyList = React.lazy(() => import(/* webpackChunkName: "ActivityApplyList" */ "../pages/Admin/Pages/ActivityApply/List"));
const ActivityApplyEdit = React.lazy(() => import(/* webpackChunkName: "ActivityApplyList" */ "../pages/Admin/Pages/ActivityApply/Edit"));
const ActivityApplyDetailEdit = React.lazy(() => import(/* webpackChunkName: "ActivityApplyDetail" */ "../pages/Admin/Pages/ActivityApply/EditActivity"));
const CarouselImageList = React.lazy(() => import(/* webpackChunkName: "CarouselImage" */ "../pages/Admin/Pages/CarouselImage/List"));
const CarouselImageEdit = React.lazy(() => import(/* webpackChunkName: "CarouselImageEdit" */ "../pages/Admin/Pages/CarouselImage/Edit"));
const TargetAudienceList = React.lazy(() => import(/* webpackChunkName: "TargetAudienceList" */ "../pages/Admin/Pages/Article/TargetAudienceList"));
const TargetAudienceEdit = React.lazy(() => import(/* webpackChunkName: "TargetAudienceEdit" */ "../pages/Admin/Pages/Article/TargetAudienceEdit"));
const SchoolCategoryList = React.lazy(() => import(/* webpackChunkName: "SchoolCategoryList" */ "../pages/Admin/Pages/School/CategoryList"));
const SchoolCategoryEdit = React.lazy(() => import(/* webpackChunkName: "SchoolCategoryEdit" */ "../pages/Admin/Pages/School/CategoryEdit"));
const SchoolList = React.lazy(() => import(/* webpackChunkName: "SchoolList" */ "../pages/Admin/Pages/School/List"));
const SchoolEdit = React.lazy(() => import(/* webpackChunkName: "SchoolEdit" */ "../pages/Admin/Pages/School/Edit"));
const ScienceVenueList = React.lazy(() => import(/* webpackChunkName: "ScienceVenueList" */ "../pages/Admin/Pages/ScienceVenue/List"));
const ScienceVenueEdit = React.lazy(() => import(/* webpackChunkName: "ScienceVenueEdit" */ "../pages/Admin/Pages/ScienceVenue/Edit"));
const VenueRouteList = React.lazy(() => import(/* webpackChunkName: "VenueRouteList" */ "../pages/Admin/Pages/VenueRoute/List"));
const VenueRouteEdit = React.lazy(() => import(/* webpackChunkName: "VenueRouteEdit" */ "../pages/Admin/Pages/VenueRoute/Edit"));
const ConfigList = React.lazy(() => import(/* webpackChunkName: "ConfiguratonList" */ "../pages/Admin/Pages/Config/List"));
const ConfigEdit = React.lazy(() => import(/* webpackChunkName: "ConfigEdit" */ "../pages/Admin/Pages/Config/Edit"));
const VolunteerList = React.lazy(() => import(/* webpackChunkName: "VolunteerList" */ "../pages/Admin/Pages/Volunteer/List"));
const VolunteerEdit = React.lazy(() => import(/* webpackChunkName: "VolunteerEdit" */ "../pages/Admin/Pages/Volunteer/Edit"));
const VolunteerApplicationList = React.lazy(() => import(/* webpackChunkName: "VolunteerApplicationList" */ "../pages/Admin/Pages/Volunteer/ApplicationList"));


export default createPages("home",
    [
        {
            pathname: "/login",
            id: "login",
            Component: Login
        },
        {
            id: "registe",
            pathname: "/registe",
            Component: Registe
        },
        {
            pathname: "/admin/*",
            id: "admin",
            Component: Admin
        },
        {
            id: "mobileLogin",
            Component: MobileLogin,
            pathname: "/mobile/login"
        },
        {
            pathname: "/404",
            id: "erorrPage",
            Component: AdminPage404
        },
        {
            pathname: "/*",
            id: "404",
            Component: AdminPage404
        },
        {
            pathname: "/example",
            id: "example",
            Component: Example
        },
        {
            pathname: "/",
            id: "slash",
            Component: Slash
        }
    ]
).createNextPages("admin", [{
    id: "example",
    pathname: "/example",
    Component: Example
}, {
    id: "setting",
    pathname: "/setting",
    title: "admin.menu.setting",
    Component: Setting
}, {
    id: "menusEdit",
    pathname: "/menus/edit",
    title: "admin.pages.menus.add.title",
    Component: AdminMenuEdit
},{
    id: "menusList",
    pathname: "/menus/list",
    title: "admin.pages.menus.list.title",
    Component: AdminMenuList
},{
    id: "langugage",
    pathname: "/language",
    title: "admin.layout.language",
    Component: AdminLanguage
},{
    id: "studentRecord",
    Component: AdminFileRecord,
    pathname: "/student/record"
},{
    id: "userList",
    Component: AdminUserList,
    pathname: "/user/list"
},{
    id: "userGroupList",
    Component: AdminUserGroupList,
    pathname: "/user/group/list"
}, {
    id: "editUserGroup",
    Component: AdminUserEditGroup,
    pathname: "/user/group/edit"
},{
    id: "resourceCategory",
    Component: ResourceCategory,
    pathname: "/resource/category",
    title: "admin.pages.article.category"
},{
    id: "resourceCategoryEdit",
    Component: ResourceCategoryEdit,
    pathname: "/resource/category/edit",
    title: "编辑内容分类"
},{
    id: "resourceArticleList",
    Component: ResourceArticle,
    pathname: "/article/list",
    title: "admin.layout.article.title.list"
},{
    id: "resourceArticleEdit",
    Component: ResourceArticleEdit,
    pathname: "/article/edit",
    title: "admin.layout.article.title.edit"
},{
    id: "resourceTargetAudienceList",
    Component: TargetAudienceList,
    pathname: "/article/target/audience/list",
    title: "admin.pages.article.target.list"
},{
    id: "resourceTargetAudienceEdit",
    Component: TargetAudienceEdit,
    pathname: "/article/target/audience/edit",
    title: "admin.pages.article.target.edit"
},{
    id: "resourceSpecialList",
    Component: ResourceSpecialList,
    pathname: "/special/list",
    title: "admin.pages.special.list.title",
    extract: ResourceSpecialListExtrac
},{
    id: "resourceSpecialEdit",
    Component: ResourceSpecialEdit,
    pathname: "/special/edit",
    title: "admin.pages.special.edit.title"
},{
    id: "resourceSpecialCategory",
    Component: ResourceSpecialCategory,
    pathname: "/special/category/list",
    title: "admin.pages.special.edit.title"
},{
    id: "resourceSpecialCategoryEdit",
    Component: ResourceSpecialCategoryEdit,
    pathname: "/special/category/edit",
    title: "admin.pages.special.edit.title"
},{
    id: "resourceSpecialGoodAt",
    Component: ResourceSpecialGoodAt,
    pathname: "/special/goodat/list",
    title: "admin.pages.special.goodat.title"
},{
    id: "resourceSpecialGoodAtEdit",
    Component: ResourceSpecialGoodAtEdit,
    pathname: "/special/goodat/edit",
    title: "admin.pages.special.goodat.edit.title"
},{
    id: "lawDocList",
    Component: LawDocList,
    pathname: "/lawdoc/list",
    title: "admin.pages.law.list.title"
},{
    id: "lawDocEdit",
    Component: LawDocEdit,
    pathname: "/lawdoc/edit",
    title: "admin.pages.law.edit.title"
},{
    id: "lawDocCategory",
    Component: LawDocCategory,
    pathname: "/lawdoc/category",
    title: "admin.pages.law.category.title"
},{
    id: "lawDocCategoryEdit",
    Component: LawDocCategoryEdit,
    pathname: "/lawdoc/category/edit",
    title: "admin.pages.law.category.edit.title"
},
{
    id: "activityList",
    Component: ActivityList,
    pathname: "/activity/list",
    title: "admin.pages.activity.list.title"
}
,{
    id: "activityEdit",
    Component: ActivityEdit,
    pathname: "/activity/edit",
    title: "admin.pages.activity.edit.title"
}, {
    id: "activityApplyList",
    Component: ActivityApplyList,
    pathname: "/activity/apply/list",
    title: "admin.pages.activity.apply.list.title"
},{
    id: "activityApplyEdit",
    Component: ActivityApplyEdit,
    pathname: "/activity/apply/edit",
    title: "admin.pages.activity.apply.edit.title"
}, {
    id: "activityApplyDetailEdit",
    Component: ActivityApplyDetailEdit,
    pathname: "/activity/apply/detail/edit",
    title: "admin.pages.activity.apply.detail.edit.title"
},{
    id: "carouselImageList",
    Component: CarouselImageList,
    pathname: "/carousel/list",
    title: "admin.pages.carousel.list.title"
},{
    id: "carouselImageEdit",
    Component: CarouselImageEdit,
    pathname: "/carousel/edit",
    title: "admin.pages.carousel.edit.title"
},{
    id: "schoolCategoryList",
    Component: SchoolCategoryList,
    pathname: "/school/category/list",
    title: "admin.pages.school.category.list.title"
},{
    id: "schoolCategoryEdit",
    Component: SchoolCategoryEdit,
    pathname: "/school/category/edit",
    title: "admin.pages.school.category.edit.title"
},{
    id: "schoolList",
    Component: SchoolList,
    pathname: "/school/list",
    title: "admin.pages.school.list.title"
},{
    id: "schoolEdit",
    Component: SchoolEdit,
    pathname: "/school/edit",
    title: "admin.pages.school.edit.title"
}, {
    id: "scienceVenueList",
    Component: ScienceVenueList,
    pathname: "/science/venue/list",
    title: "admin.pages.science.venue.list.title"
},{
    id: "scienceVenueEdit",
    Component: ScienceVenueEdit,
    pathname: "/science/venue/edit",
    title: "admin.pages.science.venue.edit.title"
}, {
    id: "venueRouteList",
    Component: VenueRouteList,
    pathname: "/science/venue/route/list",
    title: "admin.pages.science.venue.route.list.title"
},{
    id: "venueRouteEdit",
    Component: VenueRouteEdit,
    pathname: "/science/venue/route/edit",
    title: "admin.pages.science.venue.route.edit.title"
},{
    id: "configList",
    Component: ConfigList,
    pathname: "/config/list",
    title: "admin.pages.config.list.title"
},{
    id: "configEdit",
    Component: ConfigEdit,
    pathname: "/config/edit",
    title: "admin.pages.config.edit.title"
},
{
    id: "volunteerList",
    Component: VolunteerList,
    pathname: "/volunteer/list",
    title: "admin.pages.volunteer.list.title"
},
{
    id: "volunteerEdit",
    Component: VolunteerEdit,
    pathname: "/volunteer/edit",
    title: "admin.pages.volunteer.edit.title"
}, {
    id: "volunteerApplicationList",
    Component: VolunteerApplicationList,
    pathname: "/volunteer/application/list",
    title: "admin.pages.volunteer.application.list.title"
},
{
    id: "iframe",
    Component: AdminIFrame,
    pathname: "/iframe",
    mode: "fullPage"
},{
    id: "main",
    pathname: "/main",
    Component: Main,
    extract: MainHeader,
    transparentBackground: true
},{
    id: "404",
    pathname: "/404",
    Component: AdminPage404
},{
    id: "notfound",
    pathname: "/*",
    Component: AdminPage404
}], {
    urlPrefix: "/admin"
}).out();
